import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import IconButton from '@mui/joy/IconButton';
import { useContext, useState, useEffect} from 'react';
import { ContextFromSelections,FetchedDataContext } from './Context';
import { Dialog, DialogActions, DialogContent, Button, Popover, Typography, Box } from "@mui/material";
import Input from '@mui/joy/Input';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';









export default function SelectRibbonLenght() {
  const [selectedData, setSelectedData] = useContext(ContextFromSelections);
  const [value, setValue] = useState(selectedData.ribbonLenght);
  const FetchedData = useContext(FetchedDataContext);
  const [RibbonColors, setRibbonColor] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [customDialogOpen, setCustomDialogOpen] = useState(false);
  const [customValue, setCustomValue] = useState(0);
  const [isCustomValueValid, setIsCustomValueValid] = useState(false)


  useEffect(() => {
    setRibbonColor(FetchedData.get("fetchedRibbonColors"));
  },[FetchedData]);

  const ribbonColor = RibbonColors?.filter((obj) => obj.color_name === selectedData.ribbonColor)[0]
  const lenghts = ribbonColor?.ribbon_lenght
  
  

  
    
  

  useEffect(() => {
    if (/^[1-9]\d?$/.test(customValue) && 1 <= customValue && customValue <=99) {
      setIsCustomValueValid(true)
    }
    else {
      setIsCustomValueValid(false)
    }
  },[customValue])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
      handleClose();
    }, 2000);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleCustomDialogClose = () => {
    setIsCustomValueValid(false);
    setCustomDialogOpen(false);
  };

  const handleCustomLengthSubmit = () => {
    setValue(customValue)
    setSelectedData((data) => ({ ...data, ribbonLenght: customValue }));
    setCustomDialogOpen(false);  
    setIsCustomValueValid(false);
  };
  
  

  return (
    <>
    <FormControl>
      <Typography fontSize={12}>Length</Typography>
      <Select
        size='sm'
        value={value}
        onClick={!(selectedData.ribbonColor) ? handleClick : null}
        placeholder="Select Lenght"
        onChange={(event, newValue) => {
        
            setValue(newValue);
            setSelectedData((data) => ({ ...data, ribbonLenght: newValue }));
    
            
          
        }}
        renderValue={(selected) => {
          
          if (lenghts?.includes(selected.value)) {
              
            return `${selected.value} yards`
          }
          
          if (selected.value && !lenghts?.includes(selected.value)) {
            return `${selected.value} yards (custom)`
          }
          else  {
            return "Select Lenght"
          }
          
        }}
        
    
        {...(value && {
          endDecorator: (
            <IconButton
              variant="plain"
              color="neutral"
              onMouseDown={(event) => {
                event.stopPropagation();
              }}
              onClick={() => {
                setValue(null);
                setCustomValue(null);
                setSelectedData((data) => ({ ...data, ribbonLenght: null }));
              }}
            >
              <CloseTwoToneIcon/>
            </IconButton>
          ),
          indicator: null,
        })}
        sx={{
          width:{ xs: 160, sm: 170},
          height: 30,
          fontSize: 13,
          fontStyle: "500",
        }}
      >
        
        {selectedData.ribbonColor && RibbonColors
          ? RibbonColors.map((obj) => {
              if (selectedData.ribbonColor === obj.color_name) {
                return (
                  
                  <Box sx={{width:{ xs: 160, sm: 170},fontSize: 13,fontStyle: "500"}} key={obj.color_name}>
                    {obj.ribbon_lenght.map((rlength, index) => (
                      <Option key={index} value={rlength}>
                        {rlength} yards
                      </Option>
                    ))}
                    <Option  
                      onClick={(e) => {
                        e.preventDefault()
                        setCustomDialogOpen(true);
                      }} 
                      value={(!lenghts?.includes(value) ? value : null)}>
                        Custom Lenght
                    </Option>
                  </Box>
                  
                );
              }
              return null;
            })
          : <Box sx={{width:{ xs: 160, sm: 170}}}></Box>
          }
      </Select>
      </FormControl>
      <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
        >
  <Typography fontSize={14} sx={{ p: 1.5 }}>Choose color first!</Typography>
</Popover>

      <Dialog open={customDialogOpen} onClose={handleCustomDialogClose} >
        <DialogContent>
        <FormLabel sx={{fontSize: 12}}>Enter custom Lenght(in yards)</FormLabel>
          <Input
            autoFocus
            size='sm' 
            type="number"
            defaultValue={1}
            slotProps={{
              input: {
                min: 1,
                max: 99,
                step: 1,
              },
        }}
            onChange={(e) => {
                setCustomValue(e.target.value.replace(/^[0]*/, ""));
            }}
            
          />
          <FormHelperText  sx={{ fontSize: 10, textAlign: 'center'}}>
          <span style={{ display: 'inline-block', textAlign: 'left' ,paddingTop: 5}}>
            The length must be between 1 and 99 yards,<br />
             and the cost is 1.5 USD per yard.
          </span>
            </FormHelperText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCustomDialogClose} size='small'>Cancel</Button>
          <Button
            onClick={handleCustomLengthSubmit}
            disabled={!isCustomValueValid}
            size='small'
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
